import { Video } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { ZOOM_SCHEDULER_URL } from "@/constants/options";

const NAV = [
    { id: "how-it-works", label: "The Club" },
    { id: "trims", label: "Trims" },
    { id: "faq", label: "FAQ" },
];

export const Header = () => (
    <header
        data-testid="site-header"
        className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
    >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
            <button
                data-testid="header-logo-button"
                onClick={() => scrollToId("top")}
                className="flex items-center"
            >
                <img
                    src="/images/logo.png"
                    alt="RAV4 Buyers Club"
                    className="h-11 w-11 bg-white object-contain p-0.5"
                />
            </button>
            <nav className="hidden items-center gap-10 md:flex" aria-label="Primary">
                {NAV.map((item) => (
                    <button
                        key={item.id}
                        data-testid={`nav-${item.id}-link`}
                        onClick={() => scrollToId(item.id)}
                        className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-white"
                    >
                        {item.label}
                    </button>
                ))}
            </nav>
            <div className="flex items-center gap-3">
                <a
                    data-testid="header-book-call-button"
                    href={ZOOM_SCHEDULER_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hidden items-center gap-2 border border-white/25 px-4 py-2.5 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-[#2563EB] hover:bg-[#2563EB] sm:flex"
                >
                    <Video className="h-3.5 w-3.5" aria-hidden="true" />
                    Book a call
                </a>
                <button
                    data-testid="header-join-button"
                    onClick={() => scrollToId("join")}
                    className="bg-[#2563EB] px-5 py-2.5 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-white hover:text-black"
                >
                    Join — $399
                </button>
            </div>
        </div>
    </header>
);
